import React from 'react'
import { Link } from 'react-router-dom'
import {useParams} from 'react-router-dom'
import Footer from '../common/Footer'
import { useTranslation } from "react-i18next";
import { getUserRole, hasPermission } from '../../../utils/auth';

const SideMenu = ({onlyShop}) => {
  const { t } = useTranslation();
  const path = window.location.pathname;
  const { shop } = useParams();
  const shipBasePath = '/' + shop + '/ship';
  const isShipSection = path.indexOf(shipBasePath) !== -1;
  const isShipLot = path.indexOf(`${shipBasePath}/lots`) !== -1;
  const isShipOverview = isShipSection && !isShipLot;

  const role = getUserRole();
  const hp = (page) => hasPermission(role, page);

  return (
    <>
      {onlyShop ?
        <>
        <div className="side-menu">
          <div className={path.indexOf('/' + shop + '/shop') != -1 ? 'side-menu-item side-menu-active' : 'side-menu-item'}>
            <Link className="side-menu-link" to={'/' + shop + '/shop' }>{t('side_menu.shop')}</Link>
          </div>
          <Footer />
        </div>
      </>
        :
        <>
          <div className="side-menu">
            {hp('new-oripa') &&
            <div className={path.indexOf('/' + shop + '/new-oripa') != -1 ? 'side-menu-item side-menu-active' : 'side-menu-item'}>
              <Link className="side-menu-link new-oripa-menu" to={'/' + shop + '/new-oripa'}>{t('side_menu.oripa')}</Link>
            </div>
            }
            {hp('stock') &&
            <div className={path.indexOf('/' + shop + '/stock') != -1 ? 'side-menu-item side-menu-active' : 'side-menu-item'}>
              <Link className="side-menu-link" to={'/' + shop + '/stock' }>{t('side_menu.stock')}</Link>
            </div>
            }
            {hp('single') &&
            <div className={path.indexOf('/' + shop + '/single') != -1 ? 'side-menu-item side-menu-active' : 'side-menu-item'}>
              <Link className="side-menu-link" to={'/' + shop + '/single' }>{t('side_menu.single')}</Link>
            </div>
            }
            {hp('ship') &&
            <div className="side-menu-item">
              <Link className="side-menu-link" to={shipBasePath}>{t('side_menu.ship')}</Link>
              <div className="side-menu-sub">
                <div className={isShipOverview && !isShipLot ? 'side-menu-sub-item side-menu-active' : 'side-menu-sub-item'}>
                  <Link className="side-menu-sub-link" to={shipBasePath}>{t('side_menu.ship_overview')}</Link>
                </div>
                <div className={isShipLot ? 'side-menu-sub-item side-menu-active' : 'side-menu-sub-item'}>
                  <Link className="side-menu-sub-link" to={`${shipBasePath}/lots`}>{t('side_menu.ship_lot')}</Link>
                </div>
              </div>
            </div>
            }
            {hp('sales') &&
            <div className="side-menu-item">
              <Link className="side-menu-link" to={'/' + shop + '/sales' }>{t('side_menu.sales')}</Link>
              <div className="side-menu-sub">
                <div className={path.indexOf('/' + shop + '/sales') != -1 && path.indexOf('/' + shop + '/sales-') == -1 ? 'side-menu-sub-item side-menu-active' : 'side-menu-sub-item'}>
                  <Link className="side-menu-sub-link" to={'/' + shop + '/sales' }>{t('side_menu.sales_year')}</Link>
                </div>
                <div className={path.indexOf('/' + shop + '/sales-monthly') != -1 ? 'side-menu-sub-item side-menu-active' : 'side-menu-sub-item'}>
                  <Link className="side-menu-sub-link" to={'/' + shop + '/sales-monthly' }>{t('side_menu.sales_monthly')}</Link>
                </div>
              </div>
            </div>
            }
            {hp('ranking') &&
            <div className="side-menu-item">
              <Link className="side-menu-link" to={'/' + shop + '/ranking' }>{t('side_menu.ranking')}</Link>
              <div className="side-menu-sub">
              <div className={path.indexOf('/' + shop + '/ranking') != -1 && path.indexOf('/' + shop + '/ranking-') == -1 ? 'side-menu-sub-item side-menu-active' : 'side-menu-sub-item'}>
                  <Link className="side-menu-sub-link" to={'/' + shop + '/ranking' }>{t('side_menu.ranking_monthly')}</Link>
                </div>
                <div className={path.indexOf('/' + shop + '/ranking-weekly') != -1 ? 'side-menu-sub-item side-menu-active' : 'side-menu-sub-item'}>
                  <Link className="side-menu-sub-link" to={'/' + shop + '/ranking-weekly' }>{t('side_menu.ranking_weekly')}</Link>
                </div>
                <div className={path.indexOf('/' + shop + '/ranking-daily') != -1 ? 'side-menu-sub-item side-menu-active' : 'side-menu-sub-item'}>
                  <Link className="side-menu-sub-link" to={'/' + shop + '/ranking-daily' }>{t('side_menu.ranking_daily')}</Link>
                </div>
              </div>
            </div>
            }
            {hp('shop-payment') &&
            <div className="side-menu-item">
              <Link className="side-menu-link" to={'/' + shop + '/shop-payment' }>{t('side_menu.shop_payment')}</Link>
              <div className="side-menu-sub">
                {/* 決済一覧(settle, type='get')は v2 で obsolete のためメニューから除外（ルートは残置） */}
                {hp('draw-transactions') &&
                <div className={ (path === '/' + shop + '/draw-transactions') ? 'side-menu-sub-item side-menu-active' : 'side-menu-sub-item'}>
                    <Link className="side-menu-sub-link" to={'/' + shop + '/draw-transactions' }>{t('side_menu.draw_transactions')}</Link>
                </div>
                }
                {hp('ship-payments') &&
                <div className={ (path === '/' + shop + '/ship-payments') ? 'side-menu-sub-item side-menu-active' : 'side-menu-sub-item'}>
                    <Link className="side-menu-sub-link" to={'/' + shop + '/ship-payments' }>{t('side_menu.ship_payments')}</Link>
                </div>
                }
                {hp('refund-queue') &&
                <div className={ (path === '/' + shop + '/refund-queue') ? 'side-menu-sub-item side-menu-active' : 'side-menu-sub-item'}>
                    <Link className="side-menu-sub-link" to={'/' + shop + '/refund-queue' }>{t('side_menu.refund_queue')}</Link>
                </div>
                }
              </div>
            </div>
            }
            {!hp('shop-payment') && hp('draw-transactions') &&
            <div className={path.indexOf('/' + shop + '/draw-transactions') != -1 ? 'side-menu-item side-menu-active' : 'side-menu-item'}>
              <Link className="side-menu-link" to={'/' + shop + '/draw-transactions' }>{t('side_menu.draw_transactions')}</Link>
            </div>
            }
            {!hp('shop-payment') && hp('ship-payments') &&
            <div className={path.indexOf('/' + shop + '/ship-payments') != -1 ? 'side-menu-item side-menu-active' : 'side-menu-item'}>
              <Link className="side-menu-link" to={'/' + shop + '/ship-payments' }>{t('side_menu.ship_payments')}</Link>
            </div>
            }
            {!hp('shop-payment') && hp('refund-queue') &&
            <div className={path.indexOf('/' + shop + '/refund-queue') != -1 ? 'side-menu-item side-menu-active' : 'side-menu-item'}>
              <Link className="side-menu-link" to={'/' + shop + '/refund-queue' }>{t('side_menu.refund_queue')}</Link>
            </div>
            }
            {hp('user') &&
            <div className={path.indexOf('/' + shop + '/user') != -1 ? 'side-menu-item side-menu-active' : 'side-menu-item'}>
              <Link className="side-menu-link" to={'/' + shop + '/user' }>{t('side_menu.user')}</Link>
            </div>
            }
            {hp('shop') &&
            <div className="side-menu-item">
              <Link className="side-menu-link" to={'/' + shop + '/shop' }>{t('side_menu.shop')}</Link>
              <div className="side-menu-sub">
                {hp('wms-settings') &&
                <div className={path === ('/' + shop + '/wms-settings') ? 'side-menu-sub-item side-menu-active' : 'side-menu-sub-item'}>
                  <Link className="side-menu-sub-link" to={'/' + shop + '/wms-settings' }>{t('side_menu.wms_settings')}</Link>
                </div>
                }
                {hp('point-grant-rules') &&
                <div className={path === ('/' + shop + '/point-grant-rules') ? 'side-menu-sub-item side-menu-active' : 'side-menu-sub-item'}>
                  <Link className="side-menu-sub-link" to={'/' + shop + '/point-grant-rules' }>{t('side_menu.point_grant_rules')}</Link>
                </div>
                }
              </div>
            </div>
            }
            {hp('rate') &&
            <div className={path === ('/' + shop + '/rate') ? 'side-menu-item side-menu-active' : 'side-menu-item'}>
              <Link className="side-menu-link" to={'/' + shop + '/rate' }>{t('side_menu.rate')}</Link>
            </div>
            }
            {hp('staff') &&
            <div className={path.indexOf('/' + shop + '/staff') != -1 ? 'side-menu-item side-menu-active' : 'side-menu-item'}>
              <Link className="side-menu-link" to={'/' + shop + '/staff' }>{t('side_menu.staff')}</Link>
            </div>
            }
            {hp('operator-announcement') &&
            <div className={path.indexOf('/' + shop + '/operator-announcement') != -1 ? 'side-menu-item side-menu-active' : 'side-menu-item'}>
              <Link className="side-menu-link" to={'/' + shop + '/operator-announcement' }>{t('side_menu.operator_announcement')}</Link>
            </div>
            }
            <Footer />
          </div>
        </>
      }
    </>
  )
}

export default SideMenu
